module.exports = __webpack_public_path__ + "media/invite/invitation-c84ac38a.svg";